var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;
var exports = {};
!function (e, t) {
  exports = t();
}(exports, () => (() => {
  "use strict";

  var e,
    t = {
      588: (e, t, n) => {
        n.d(t, {
          default: () => d
        });
        const r = (...e) => {},
          o = e => e.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&"),
          i = e => null !== e && "Object" === (null == e ? void 0 : e.constructor.name),
          s = (e = "") => e.normalize("NFD").replace(/\p{Diacritic}/gu, ""),
          l = (e, t) => {
            const n = e.length;
            if (!n) return [];
            if (i(e[0])) {
              for (let r = 0; r < n; r++) if (!(t in e[r])) throw new Error("e03");
              return e;
            }
            return e.reduce(function (e, n) {
              return e.push({
                [t]: n && "string" == typeof n ? n : JSON.stringify(n)
              }), e;
            }, []);
          },
          a = {
            get: async function (e, t) {
              return async function (e) {
                const t = await e.text(),
                  n = t && JSON.parse(t);
                return e.ok ? n : Promise.reject(n && n.message || e.statusText);
              }(await fetch(e, t || {
                method: "GET"
              }));
            }
          },
          u = (e = {}) => {
            const {
              hasDiacritics: t
            } = e;
            let n = {};
            const r = String.fromCharCode(0);
            function o(e = "") {
              return e = `${e}`, t && (e = s(e)), e.toLowerCase().trim().split(/\s+/);
            }
            return {
              add: function (e, t = "", i) {
                if (!e) return;
                let s,
                  l = n;
                (e = e.constructor === Array ? e : [e]).forEach(e => {
                  o("string" == typeof e ? e : e[t]).filter(e => e).forEach(t => {
                    l = n;
                    for (let e = 0, n = t.length; e < n; e++) s = t[e], l = l[s] || (l[s] = {});
                    const o = "string" == typeof e ? e : i && i(e) || JSON.stringify(e);
                    l[r] ? l[r][o] = e : l[r] = {
                      [o]: e
                    };
                  });
                });
              },
              clear: function () {
                n = {};
              },
              search: function (e, t) {
                const i = o(e),
                  s = [];
                let l = {};
                i.forEach(e => {
                  s.push(function (e) {
                    let t,
                      o = n,
                      i = {};
                    for (let n = 0, r = e.length; n < r; n++) if (t = e[n], o = o[t], void 0 === o) return {};
                    const s = [o],
                      l = [e];
                    let a;
                    for (; s.length;) for (a in e = l.pop(), o = s.pop(), o) a !== r ? (s.push(o[a]), l.push(e + a)) : i = Object.assign(i, o[r]);
                    return i;
                  }(e));
                }), l = s.reduce((e, t) => {
                  const n = {};
                  return Object.keys(e).filter(e => t[e]).forEach(t => {
                    n[t] = e[t];
                  }), n;
                }), l = Object.values(l);
                const a = l.length;
                return t && a > t && (l.length = t), {
                  suggestions: l,
                  count: a
                };
              }
            };
          };
        function d(e) {
          var t, n, d;
          if (!e.input) throw new Error("e01");
          if (!i(e.source)) throw new Error("e02");
          const c = document,
            p = c.createElement("div"),
            f = e.debounceRemote || 100,
            h = e.preventSubmit || !1,
            m = e.minLength || 1,
            v = !1 !== e.hint,
            g = e.autoSelect || !1,
            y = e.templates,
            b = u({
              hasDiacritics: e.diacritics
            }),
            w = e.source.identifier || "label",
            E = e.source.groupIdentifier || "",
            C = e => `${e[w]}`,
            x = e.display || C,
            L = e.source.identity || C,
            O = e.onSubmit || r,
            q = (null === (t = e.source.dataTokens) || void 0 === t ? void 0 : t.constructor) === Array ? e.source.dataTokens : void 0,
            k = e.source.transform || (e => e),
            N = e.source.local || null,
            T = (null === (n = e.source.remote) || void 0 === n ? void 0 : n.url) && e.source.remote.wildcard ? e.source.remote : null,
            A = (null === (d = e.source.prefetch) || void 0 === d ? void 0 : d.url) ? {
              when: "onInit",
              done: !1,
              ...e.source.prefetch
            } : null,
            S = {
              wrapper: "",
              input: "tt-input",
              hint: "tt-hint",
              highlight: "tt-highlight",
              hide: "tt-hide",
              show: "tt-show",
              list: "tt-list",
              selected: "tt-selected",
              header: "tt-header",
              footer: "tt-footer",
              loader: "tt-loader",
              suggestion: "tt-suggestion",
              group: "tt-group",
              empty: "tt-empty",
              notFound: "tt-notFound",
              ...(e.classNames || {})
            };
          if (!N && !A && !T) throw new Error("e02");
          const $ = {
            query: "",
            items: [],
            count: 0,
            limit: e.limit || 5
          };
          let j,
            I,
            D = {},
            F = {},
            J = !1,
            P = "";
          y && (y.header = "function" == typeof y.header ? y.header : void 0, y.footer = "function" == typeof y.footer ? y.footer : void 0, y.notFound = "function" == typeof y.notFound ? y.notFound : void 0, y.group = "function" == typeof y.group ? y.group : void 0, y.suggestion = "function" == typeof y.suggestion ? y.suggestion : void 0, y.loader = "function" == typeof y.loader ? y.loader : void 0, y.empty = "function" == typeof y.empty ? y.empty : void 0);
          const W = (e = []) => {
            ie(l(e, w));
          };
          N && W(N);
          const B = e.input;
          B.classList.add(S.input);
          const H = window.getComputedStyle(B),
            R = c.createElement("div");
          R.className = `typeahead-standalone${e.className ? ` ${e.className}` : ""}${S.wrapper ? ` ${S.wrapper}` : ""}`, $.container = R;
          const z = B.parentNode,
            G = [...z.children].indexOf(B);
          z.removeChild(B), R.appendChild(B), z.insertBefore(R, z.children[G]);
          const M = B.cloneNode();
          function U() {
            if (!A || A.done) return;
            let e = [];
            a.get("function" == typeof A.url ? A.url() : A.url, null == A ? void 0 : A.requestOptions).then(t => {
              e = k(t), e = l(e, w), ie(e);
            }, e => {
              console.error("e04", e);
            }).finally(() => {
              "function" == typeof A.process && A.process(e);
            }), A.done = !0;
          }
          v && function (e) {
            ["id", "name", "placeholder", "required", "aria-label"].forEach(t => e.removeAttribute(t)), e.setAttribute("readonly", "true"), e.setAttribute("aria-hidden", "true"), e.style.marginTop = `-${B.offsetHeight + parseInt(H.marginBottom)}px`, e.tabIndex = -1, e.className = S.hint, B.after(e);
          }(M), p.classList.add(S.list, S.hide), p.tabIndex = 0, p.setAttribute("aria-label", "menu-options"), p.setAttribute("role", "listbox"), p.style.position = "absolute", p.style.width = `${B.offsetWidth}px`, p.style.marginTop = `${B.offsetHeight + parseInt(H.marginTop)}px`, R.appendChild(p), A && "onInit" === A.when && U();
          const V = () => {
              p.classList.remove(S.hide);
            },
            K = () => {
              I && window.clearTimeout(I);
            },
            Q = () => {
              $.items = [], M.value = "", P = "", p.classList.add(S.hide);
            },
            X = () => {
              B.dispatchEvent(new InputEvent("input", {
                bubbles: !0,
                inputType: "insertCompositionText",
                data: B.value
              }));
            },
            Y = (e = !1) => {
              if (!$.items.length && $.query) {
                Q(), Z();
                const t = (null == y ? void 0 : y.notFound) && y.notFound($);
                if (!t) return !0;
                const n = e => {
                  const t = c.createElement("div");
                  t.classList.add(S.notFound), de(t, e), p.appendChild(t);
                };
                return T ? (D[JSON.stringify($.query)] || e && !J) && n(t) : n(t), V(), !0;
              }
            },
            Z = () => {
              for (; p.firstChild;) p.firstChild.remove();
            },
            _ = () => {
              if (!(null == y ? void 0 : y.loader)) return;
              if (!J) {
                const e = p.querySelector(`.${S.loader}`);
                return void (e && p.removeChild(e));
              }
              const e = c.createElement("div");
              e.classList.add(S.loader), de(e, y.loader()), (null == y ? void 0 : y.footer) ? p.insertBefore(e, p.querySelector(`.${S.footer}`)) : p.appendChild(e);
            },
            ee = () => {
              var t;
              if (Y()) return;
              Z();
              const n = e => {
                  const t = c.createElement("div");
                  return t.classList.add(S.suggestion), t.setAttribute("role", "option"), t.setAttribute("aria-selected", "false"), t.setAttribute("aria-label", x(e)), (null == y ? void 0 : y.suggestion) ? de(t, y.suggestion(e, $)) : t.textContent = e[w] || "", t;
                },
                r = e => {
                  const t = c.createElement("div");
                  return t.classList.add(S.group), t.setAttribute("role", "group"), t.setAttribute("aria-label", e), (null == y ? void 0 : y.group) ? de(t, y.group(e, $)) : t.textContent = e || "", t;
                },
                o = c.createDocumentFragment(),
                i = [];
              if (null == y ? void 0 : y.header) {
                const e = c.createElement("div");
                e.classList.add(S.header), e.setAttribute("role", "presentation"), de(e, y.header($)) && o.appendChild(e);
              }
              for (const [t, s] of $.items.entries()) {
                if (t === $.limit) break;
                if (s[E] && !i.includes(s[E])) {
                  i.push(s[E]);
                  const e = r(s[E]);
                  o.appendChild(e);
                }
                const l = n(s);
                l.addEventListener("click", e => {
                  Q(), j = s, B.value = x(s, e), X();
                }), s === j && (l.classList.add(S.selected), l.setAttribute("aria-selected", "true")), o.appendChild(l), e.highlight && ae(l, $.query);
              }
              if (null == y ? void 0 : y.footer) {
                const e = c.createElement("div");
                e.classList.add(S.footer), e.setAttribute("role", "presentation"), de(e, y.footer($)) && o.appendChild(e);
              }
              p.appendChild(o), v && ue(j || $.items[0]), null === (t = p.querySelector(`.${S.selected}`)) || void 0 === t || t.scrollIntoView({
                block: "nearest"
              }), V();
            },
            te = () => {
              var e, t;
              K();
              const n = B.value.replace(/\s{2,}/g, " ").trim();
              if ((null == y ? void 0 : y.empty) && !n.length) {
                const t = y.empty($);
                if ($.query = "", null === (e = $.defaultItems) || void 0 === e ? void 0 : e.length) return $.items = l(k($.defaultItems), w), ee();
                Q(), Z();
                const n = c.createElement("div");
                return n.classList.add(S.empty), de(n, t), t && p.appendChild(n), V();
              }
              if (n.length >= m) {
                $.query = n, re();
                const e = JSON.stringify($.query);
                T && $.items.length < $.limit && (null === (t = F[e]) || void 0 === t ? void 0 : t.length) && re(F[e]), ee(), I = window.setTimeout(function () {
                  $.items.length < $.limit && !J && oe();
                }, f);
              } else $.query = "", Q();
            },
            ne = (t = "") => (e.diacritics && (t = s(t)), t.toLowerCase()),
            re = e => {
              let {
                suggestions: t,
                count: n
              } = b.search($.query, $.limit);
              if (null == e ? void 0 : e.length) {
                e.push(...t);
                const r = {};
                e.forEach(e => {
                  r[L(e)] = e;
                }), t = Object.values(r), n = t.length;
              }
              se(t), E && le(t), $.items = t, $.count = n, j = void 0, g && $.items.length && (j = $.items[0]);
            },
            oe = () => {
              if (!T) return;
              J = !0;
              const e = $.query,
                t = JSON.stringify(e);
              if (D[t] || !$.query.length) return J = !1, void Y(!0);
              _();
              let n = [];
              a.get(("function" == typeof T.url ? T.url() : T.url).replace(T.wildcard, e), null == T ? void 0 : T.requestOptions).then(e => {
                n = k(e), n = l(n, w), ie(n);
              }, e => {
                console.error("e05", e);
              }).finally(() => {
                D[t] = !0, F[t] = n || [], J = !1, _(), n.length && $.query.length && (re(n), ee()), $.query.length && e !== $.query && oe(), Y(!0);
              });
            };
          function ie(e) {
            e.length && (b.add(e, w, L), q && q.forEach(t => {
              b.add(e, t, L);
            }));
          }
          const se = e => {
              e.sort((e, t) => {
                const n = e[w].toLowerCase().startsWith($.query.toLowerCase()),
                  r = t[w].toLowerCase().startsWith($.query.toLowerCase());
                return n && !r || n && e[w].length < t[w].length ? -1 : 0;
              });
            },
            le = e => {
              e.sort((e, t) => !e[E] || e[E] < t[E] ? -1 : e[E] > t[E] ? 1 : 0);
            },
            ae = (t, n) => {
              const r = (e, t) => {
                  let n;
                  for (let o = 0; o < e.childNodes.length; o++) n = e.childNodes[o], 3 === n.nodeType ? o += t(n) ? 1 : 0 : r(n, t);
                },
                i = ((e, t) => {
                  const n = o(e);
                  return new RegExp("(" + n + ")", "i");
                })(n);
              n && r(t, t => {
                var n;
                let r = i.exec(t.data);
                e.diacritics && !r && (r = i.exec(s(t.data)));
                const o = c.createElement("span");
                if (o.className = S.highlight, r) {
                  const e = t.splitText(r.index);
                  e.splitText(r[0].length), o.appendChild(e.cloneNode(!0)), null === (n = null == t ? void 0 : t.parentNode) || void 0 === n || n.replaceChild(o, e);
                }
                return !!r;
              });
            },
            ue = t => {
              const n = B.value;
              if (n && x(t) !== n && 0 === ne(x(t)).indexOf(ne(n).replace(/\s{2,}/g, " ").trimStart())) {
                const r = x(t),
                  i = new RegExp(o($.query), "i");
                let l = i.exec(r);
                e.diacritics && !l && (l = i.exec(s(r))), l && (M.value = n.replace(/\s?$/, "") + r.substring(l[0].length));
              } else M.value = "";
            },
            de = (e, t) => {
              const n = c.createElement("template");
              return n.innerHTML = t, e.appendChild(n.content), t;
            };
          p.addEventListener("mousedown", function (e) {
            e.stopPropagation(), e.preventDefault();
          });
          const ce = e => {
            Q(), b.clear(), N && !e && W(N), D = {}, F = {}, A && (A.done = !1);
          };
          return B.addEventListener("keydown", e => {
            if (!B.value.length || "Escape" === e.key) return Q();
            if ($.items.length && ("ArrowUp" === e.key || "ArrowDown" === e.key)) return "ArrowDown" === e.key ? (e => {
              const t = $.items.length >= $.limit ? $.limit : $.items.length;
              if (!j) return j = $.items[0], void (B.value = x(j, e));
              if (j === $.items[t - 1]) return j = void 0, void (B.value = P);
              for (let e = 0; e < t - 1; e++) if (j === $.items[e]) {
                j = $.items[e + 1];
                break;
              }
              B.value = x(j, e);
            })(e) : (e => {
              const t = $.items.length >= $.limit ? $.limit : $.items.length;
              if (j === $.items[0]) return j = void 0, void (B.value = P);
              if (j) {
                for (let e = t - 1; e > 0; e--) if (j === $.items[e] || 1 === e) {
                  j = $.items[e - 1];
                  break;
                }
              } else j = $.items[t - 1];
              B.value = x(j, e);
            })(e), ee(), e.preventDefault(), void e.stopPropagation();
            const t = function (t = !1) {
              if (!j && t && $.items.length && (j = $.items[0]), j) return Q(), B.value = x(j, e), X(), j;
            };
            if ("Enter" === e.key) return h && e.preventDefault(), void O(e, t());
            "Tab" !== e.key || p.classList.contains(S.hide) || (e.preventDefault(), t(!0));
          }), B.addEventListener("input", e => {
            ("insertCompositionText" !== e.inputType || e.isComposing) && (P = B.value, te());
          }), B.addEventListener("blur", () => {
            setTimeout(() => {
              c.activeElement !== B && Q();
            }, 50);
          }), B.addEventListener("focus", () => {
            A && "onFocus" === A.when && U(), te();
          }), {
            addToIndex: W,
            reset: ce,
            destroy: () => {
              K(), ce(), R.replaceWith(B.cloneNode());
            }
          };
        }
      }
    },
    n = {};
  function r(e) {
    var o = n[e];
    if (void 0 !== o) return o.exports;
    var i = n[e] = {
      exports: {}
    };
    return t[e](i, i.exports, r), i.exports;
  }
  r.m = t, e = [], r.O = (t, n, o, i) => {
    if (!n) {
      var s = 1 / 0;
      for (d = 0; d < e.length; d++) {
        for (var [n, o, i] = e[d], l = !0, a = 0; a < n.length; a++) (!1 & i || s >= i) && Object.keys(r.O).every(e => r.O[e](n[a])) ? n.splice(a--, 1) : (l = !1, i < s && (s = i));
        if (l) {
          e.splice(d--, 1);
          var u = o();
          void 0 !== u && (t = u);
        }
      }
      return t;
    }
    i = i || 0;
    for (var d = e.length; d > 0 && e[d - 1][2] > i; d--) e[d] = e[d - 1];
    e[d] = [n, o, i];
  }, r.d = (e, t) => {
    for (var n in t) r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
      enumerable: !0,
      get: t[n]
    });
  }, r.o = (e, t) => Object.prototype.hasOwnProperty.call(e, t), (() => {
    var e = {
      179: 0,
      53: 0
    };
    r.O.j = t => 0 === e[t];
    var t = (t, n) => {
        var o,
          i,
          [s, l, a] = n,
          u = 0;
        if (s.some(t => 0 !== e[t])) {
          for (o in l) r.o(l, o) && (r.m[o] = l[o]);
          if (a) var d = a(r);
        }
        for (t && t(n); u < s.length; u++) i = s[u], r.o(e, i) && e[i] && e[i][0](), e[i] = 0;
        return r.O(d);
      },
      n = (this || _global).webpackChunktypeahead = (this || _global).webpackChunktypeahead || [];
    n.forEach(t.bind(null, 0)), n.push = t.bind(null, n.push.bind(n));
  })();
  var o = r.O(void 0, [53], () => r(588));
  return (o = r.O(o)).default;
})());
//# sourceMappingURL=typeahead-standalone.js.map
export default exports;
export const typeahead = exports.typeahead;